/**
 * MethodScript Syntax Data
 * Auto-generated by generate-syntax-data.js from command-parameters.json
 *
 * This file provides the single source of truth for MethodScript keywords and commands.
 */

/**
 * Control flow keywords
 * These are language constructs for control flow and variable declaration
 */
export const controlKeywords = [
    'var', 'array', 'if', 'elseif', 'else', 'endif', 'loop', 'endloop', 'breakloop', 'on_finished:'
] as const;

/**
 * Measurement loop commands
 * Commands that start with meas_loop_ for various electrochemical techniques
 */
export const measurementCommands = [
    'meas_loop_acv',
    'meas_loop_ca',
    'meas_loop_ca_alt_mux',
    'meas_loop_cp',
    'meas_loop_cp_alt_mux',
    'meas_loop_cv',
    'meas_loop_dpv',
    'meas_loop_eis',
    'meas_loop_eis_dual',
    'meas_loop_geis',
    'meas_loop_lsp',
    'meas_loop_lsv',
    'meas_loop_npv',
    'meas_loop_ocp',
    'meas_loop_ocp_alt_mux',
    'meas_loop_pad',
    'meas_loop_swv',
] as const;

/**
 * Standard commands
 * All regular MethodScript commands (excluding measurement loops and control keywords)
 */
export const standardCommands = [
    'abort',
    'add_var',
    'alter_vartype',
    'array_get',
    'array_set',
    'await_int',
    'battery_perc',
    'beep',
    'bit_and_var',
    'bit_inv_var',
    'bit_lsl_var',
    'bit_lsr_var',
    'bit_or_var',
    'bit_xor_var',
    'cell_off',
    'cell_on',
    'copy_var',
    'display_btns',
    'display_clear',
    'display_draw',
    'display_filebrowse',
    'display_icon',
    'display_inp_num',
    'display_keyboard',
    'display_progress',
    'display_scroll_add',
    'display_scroll_get',
    'display_text',
    'div_var',
    'drop_detect_loop',
    'file_close',
    'file_open',
    'float_to_int',
    'float_to_int_round',
    'get_gpio',
    'get_gpio_msk',
    'get_progress',
    'get_time',
    'hibernate',
    'i2c_config',
    'i2c_read',
    'i2c_read_byte',
    'i2c_write',
    'i2c_write_byte',
    'i2c_write_read',
    'int_to_float',
    'linear_fit',
    'load_saved_end',
    'load_saved_start',
    'load_saved_str',
    'load_saved_var',
    'log_var',
    'mean',
    'meas',
    'meas_fast_ca',
    'meas_fast_cv',
    'meas_ms_eis',
    'meas_scp',
    'mod_var',
    'mul_var',
    'mux_config',
    'mux_get_channel_count',
    'mux_set_channel',
    'notify_led',
    'pck_add',
    'pck_end',
    'pck_start',
    'peak_detect',
    'pow_var',
    'qr_scan',
    'rtc_get',
    'save_str',
    'save_var',
    'send_string',
    'set_acquisition_frac',
    'set_acquisition_frac_autoadjust',
    'set_autoranging',
    'set_bipot_mode',
    'set_bipot_potential',
    'set_channel_sync',
    'set_cr',
    'set_e',
    'set_e_aux',
    'set_gpio',
    'set_gpio_cfg',
    'set_gpio_msk',
    'set_gpio_pullup',
    'set_i',
    'set_int',
    'set_ir_comp',
    'set_max_bandwidth',
    'set_pgstat_chan',
    'set_pgstat_mode',
    'set_poly_we_mode',
    'set_pot_range',
    'set_range',
    'set_range_minmax',
    'set_scan_dir',
    'set_script_output',
    'smooth',
    'store_str',
    'store_var',
    'str',
    'sub_var',
    'subarray',
    'timer_get',
    'timer_start',
    'trim_enable',
    'wait',
] as const;

/**
 * Conditional operators
 * Operators used in if/elseif conditions
 */
export const operators = ['==', '!=', '<=', '>=', '<', '>', '&&', '||'] as const;

/**
 * All commands combined for convenience
 * Includes both measurement loop and standard commands
 */
export const allCommands = [...measurementCommands, ...standardCommands] as const;

/**
 * All keywords and commands
 * Complete list including control keywords, measurement commands, and standard commands
 */
export const allKeywords = [...controlKeywords, ...allCommands] as const;
